module.exports = __webpack_public_path__ + "img/contributionGreen.5248552c.png";